<template>
  <div class="search-machine-advert-group">
    <div class="el-search vue-top-padding radius">
      <div class="el-left">
        <el-button v-hasPerm="['advert:piano:add']" type="primary" size="small" icon="el-icon-plus" @click="addPiano">{{
          $t("common.add")
        }}</el-button>
      </div>
      <div class="el-right">
        <el-form
          ref="machineAdvertGroup"
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="name">
            <el-input v-model="search.name" :placeholder="$t('cAdvertPiano.name')"></el-input>
          </el-form-item>
          <el-form-item prop="equipmentNo">
            <el-input v-model="search.equipmentNo" :placeholder="$t('consoles.sbh')"></el-input>
          </el-form-item>
          <el-form-item prop="adName">
            <el-input v-model="search.adName" :placeholder="$t('cAdvertPiano.ggName')"></el-input>
          </el-form-item>
          <el-form-item prop="state">
            <el-select v-model="search.state" :placeholder="$t('cAdvertPiano.status')" clearable>
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
            <el-button @click="resetSearch('machineAdvertGroup')" icon="el-icon-refresh">{{
              $t("common.reset")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SearchAdvertPiano",
    props: {
      search: Object,
      stateList: Array
    },
    data() {
      return {
        formData: {
          name: "",
          adTeamName: "",
          ggName: "",
          planStatus: ""
        }
      };
    },
    methods: {
      addPiano() {
        this.$emit("add");
      },
      onSubmit() {
        this.$emit("onSubmit", this.search);
      },
      resetSearch(formName) {
        this.$refs[formName].resetFields();
        this.$toolUtil.clearForm(this.search);
        this.$emit("resetSearch", this.search);
      }
    }
  };
</script>

<style scoped></style>
